export default {
  GET_CHANGELOG_ENTRIES: (state) => {
    return state.entries;
  },
  GET_CHANGELOG_HAS_MORE: (state) => {
    return state.lastEvaluatedKey !== null;
  },
};
